import { createContext } from 'react';
import _noop from 'lodash/noop';

import { getEmptyEntitySelectionContext } from '@trqk/utils';

const {
    activeEntities,
    disableSelection,
    entities,
    onSelectEntity,
    priorSelectedEntityId,
    selectedEntity,
    selectedEntityId,
    userId,
    viewAll,
} = getEmptyEntitySelectionContext();

export const EntityContext = createContext<EntityProviderValue>({
    activeEntities,
    disableSelection,
    entities,
    loading: false,
    modifiedAt: 0,
    noSelectedEntity: false,
    onSelectEntity,
    priorSelectedEntityId,
    selectedEntity,
    selectedEntityId,
    sendEntitySelectionEvent: _noop,
    setStateListeners: _noop,
    userId,
    viewAll,
});
